import { create, test, enforce, only } from 'vest'
import isEmail from 'validator/es/lib/isEmail'

enforce.extend({ isEmail })

const suite = create('RegisterCompany', (data = {}, field) => {
    // Todo: find a way to include i18n here instead of passing language as a prop
    const mandatoryMessage = data.language.value === 'en' ? 'This field is mandatory' : 'Detta fält är obligatoriskt'

    only(field)

    test('area', mandatoryMessage, () => enforce(data.area).isNotEmpty())
    test('how_long', mandatoryMessage, () => enforce(data.how_long).isNotEmpty())
    test('org_nr', mandatoryMessage, () => enforce(data.org_nr).isNotEmpty())
    test('company_name', mandatoryMessage, () => enforce(data.company_name).isNotEmpty())
    test('name', mandatoryMessage, () => enforce(data.name).isNotEmpty())
    test('email', mandatoryMessage, () => enforce(data.email).isNotEmpty())
    test('email', mandatoryMessage, () => enforce(data.email).isEmail())
    test('cell_phone', mandatoryMessage, () => enforce(data.cell_phone).isNotEmpty())
})

export default suite